import apiSetting from '../apiSetting';
import { POST_API_PATH, GET_API_PATH } from "../../../constants"

// 取得所有借車申請
export const getTruckLoanApplications = async (query = {}) => {
    const params = new URLSearchParams(query).toString();
    return await apiSetting({
        method: 'GET',
        url: `${GET_API_PATH.GET_URL_TRUCK_LOAN_APPLICATIONS}${params ? `?${params}` : ''}`,
    });
};

// 取得待審核的借車申請
// export const getPendingTruckLoanApplications = async (query = {}) => {
//     const params = new URLSearchParams(query).toString();
//     return await apiSetting({
//         method: 'GET',
//         url: `${GET_API_PATH.GET_URL_TRUCK_LOAN_PENDING}?${params}`,
//     });
// };

// 取得已核准的借車申請
// export const getApprovedTruckLoanApplications = async (query = {}) => {
//     const params = new URLSearchParams(query).toString();
//     return await apiSetting({
//         method: 'GET',
//         url: `${GET_API_PATH.GET_URL_TRUCK_LOAN_APPROVED}?${params}`,
//     });
// };

// 取得已駁回的借車申請
// export const getRejectedTruckLoanApplications = async (query = {}) => {
//     const params = new URLSearchParams(query).toString();
//     return await apiSetting({
//         method: 'GET',
//         url: `${GET_API_PATH.GET_URL_TRUCK_LOAN_REJECTED}?${params}`,
//     });
// };

// 取得已歸還的借車申請
// export const getReturnedTruckLoanApplications = async (query = {}) => {
//     const params = new URLSearchParams(query).toString();
//     return await apiSetting({
//         method: 'GET',
//         url: `${GET_API_PATH.GET_URL_TRUCK_LOAN_RETURNED}?${params}`,
//     });
// };

// 取得單一借車申請
export const getTruckLoanApplicationById = async (id) => {
    return await apiSetting({
        method: 'GET',
        url: `${GET_API_PATH.GET_URL_TRUCK_LOAN_APPLICATION_BY_ID}/${id}`,
    });
};

// 根據派車單ID取得借車申請
export const getTruckLoanApplicationByDeliverOrderId = async (deliverOrderId) => {
    return await apiSetting({
        method: 'GET',
        url: `${GET_API_PATH.GET_URL_TRUCK_LOAN_APPLICATION_BY_DELIVER_ORDER_ID}/${deliverOrderId}`,
    });
};

// 新增借車申請
export const createTruckLoanApplication = async (data) => {
    return await apiSetting({
        method: 'POST',
        url: POST_API_PATH.POST_URL_CREATE_TRUCK_LOAN_APPLICATION,
        data,
    });
};

// 核准借車申請
export const approveTruckLoanApplication = async (data) => {
    return await apiSetting({
        method: 'POST',
        url: POST_API_PATH.POST_URL_APPROVE_TRUCK_LOAN_APPLICATION,
        data,
    });
};

// 拒絕借車申請
export const rejectTruckLoanApplication = async (data) => {
    return await apiSetting({
        method: 'POST',
        url: POST_API_PATH.POST_URL_REJECT_TRUCK_LOAN_APPLICATION,
        data,
    });
};

// 取消借車申請
export const cancelTruckLoanApplication = async (data) => {
    return await apiSetting({
        method: 'POST',
        url: `${POST_API_PATH.POST_URL_CANCEL_TRUCK_LOAN_APPLICATION}`,
        data,
    });
};

// 核准取消申請
export const approveCancelRequest = async (data) => {
    return await apiSetting({
        method: 'POST',
        url: `${POST_API_PATH.POST_URL_APPROVE_CANCEL_REQUEST}`,
        data,
    });
};

// 歸還車輛
export const returnTruckLoanApplication = async (data) => {
    return await apiSetting({
        method: 'POST',
        url: POST_API_PATH.POST_URL_RETURN_TRUCK_LOAN_APPLICATION,
        data,
    });
};

export const approveReturn = async (data) => {
    return await apiSetting({
        method: 'POST',
        url: POST_API_PATH.POST_URL_APPROVE_RETURN_TRUCK_LOAN_APPLICATION,
        data,
    });
};